import { render, staticRenderFns } from "./details-product.vue?vue&type=template&id=dbe68d38&scoped=true"
import script from "./details-product.vue?vue&type=script&lang=js"
export * from "./details-product.vue?vue&type=script&lang=js"
import style0 from "./details-product.vue?vue&type=style&index=0&id=dbe68d38&prod&scoped=true&lang=css"
import style1 from "./details-product.vue?vue&type=style&index=1&id=dbe68d38&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbe68d38",
  null
  
)

export default component.exports